import React from 'react';
import Box from '@mui/material/Box';

export function CenterOutDivider({
  thickness = 1,
  color = 'divider',
  animate = true,
  delay = 0,
  duration = 600,
  fullBleed = false,
  sx,
  ...props
}) {
  const delayStr = typeof delay === 'number' ? `${delay}s` : delay;
  const durationStr = typeof duration === 'number' ? `${duration}ms` : duration;

  return (
    <Box
      aria-hidden
      sx={{
        my: 3,
        position: 'relative',
        height: thickness,
        ...(fullBleed && {
          width: '100vw',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
        }),
        '@keyframes growX': { from: { transform: 'scaleX(0)' }, to: { transform: 'scaleX(1)' } },
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '50%',
          right: 0,
          height: thickness,
          backgroundColor: (theme) =>
            color === 'divider' ? theme.palette.divider : color,
          ...(animate && {
            transform: 'scaleX(0)',
            transformOrigin: 'left center',
            animation: `growX ${durationStr} ease-out forwards`,
            animationDelay: delayStr,
          }),
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: '50%',
          left: 0,
          height: thickness,
          backgroundColor: (theme) =>
            color === 'divider' ? theme.palette.divider : color,
          ...(animate && {
            transform: 'scaleX(0)',
            transformOrigin: 'right center',
            animation: `growX ${durationStr} ease-out forwards`,
            animationDelay: delayStr,
          }),
        }}
      />
      <Box
        sx={{
          '@media (prefers-reduced-motion: reduce)': {
            '&, & > *': { animation: 'none !important', transform: 'none !important' },
          },
        }}
      />
    </Box>
  );
}

